import { render, staticRenderFns } from "./FeaturedItemList.vue?vue&type=template&id=9761b94a&scoped=true"
import script from "./FeaturedItemList.vue?vue&type=script&lang=ts"
export * from "./FeaturedItemList.vue?vue&type=script&lang=ts"
import style0 from "./FeaturedItemList.vue?vue&type=style&index=0&id=9761b94a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9761b94a",
  null
  
)

export default component.exports